import { useEffect, useState } from 'react';
import {  verifyToken, verifyPasswordResetToken } from '../../forgotPasswordGateway';

export interface GetUserProfileResponse {
    loading: boolean;
    unauthorisedError: boolean;
}

export const useVerifyToken = (token: string): GetUserProfileResponse => {
    const [loading, setLoading] = useState(true);
    const [unauthorisedError, setUnauthorisedError] = useState(false);

    useEffect(() => {
        const fetch = async (): Promise<void> => {
            try {
                await verifyToken(token);
                setLoading(false);
            } catch (e) {
                setLoading(false);
                setUnauthorisedError(true);
            }
        };

        void fetch();
    }, [token]);

    return { loading, unauthorisedError };
};


export const usePasswordResetVerifyToken = (token: string, username: string): GetUserProfileResponse => {
    const [loading, setLoading] = useState(true);
    const [unauthorisedError, setUnauthorisedError] = useState(false);

    useEffect(() => {
        const fetch = async (): Promise<void> => {
            try {
                await verifyPasswordResetToken(token, username);
                setLoading(false);
            } catch (e) {
                setLoading(false);
                setUnauthorisedError(true);
            }
        };

        void fetch();
    }, [token, username]);

    return { loading, unauthorisedError };
};
